module.exports = __webpack_public_path__ + "img/IMG_1627_Foamcore.deb0f641.jpg";